import AttachmentDetails from './schema/AttachmentDetails';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import MessageDetails from './schema/MessageDetails';

import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AutomatedMessage", webpackPrefetch: true */ './lazyIndex')
);

export const lazySendAutomatedMessage = new LazyImport(lazyModule, m => m.sendAutomatedMessage);

export { MessageDetails, AttachmentDetails, CreateItemResponse };
